import styled from 'styled-components';
import { Button } from 'components/Button';
import { Row } from 'components/Layout/Grid';
import Loading from 'components/Loading';

interface INewAnswerButton {
  able?: boolean;
};

export const NewBudgetContent = styled(Row)`
  padding-bottom: 20px;
  align-items: center;
`;

export const NewAnswerButton = styled.button<INewAnswerButton>`
  width: 140px;
  height: 30px;
  padding: 5px;
  border-radius: 6px;
  cursor:  ${(props) => props.able ? "pointer" : "default"};
  border: 1px solid ${(props) => props.able ? "#0E4C54" : "#BEBEBE"};

  display: flex;
  align-items: center;
  justify-content: center;

  p{
    color:  ${(props) => props.able ? "#0E4C54" : "#BEBEBE"};
    font-weight: 600;
    font-size: 13px !important;
  }

  img{
    height: 14px;
    width:14px;
  }
`;

export const RemoveButton = styled(Button)`
  width: 64px;
  height: 30px;
  margin-left: 10px;
  border: 1px solid #E02828;

  p{
    color: #E02828;
    font-weight: 600;
    font-size: 12px !important;
  }
`;

export const CustomerApproval = styled(Row)`
  width: 200px;
  margin-left: 30px;
  align-items: center;

  img{
    width: 16px;
    height: 16px;
  }

  p{
    color: #14A86B;
    margin-left: 6px;
    font-weight: 700;
    font-size: 14px !important;
  }
  /* background-color: red; */
`;

export const AnotherCd = styled(Row)`
  width: 100%;
  height: 26px;
  align-items: center;
  justify-content: center;
  background-color: #6EE4D9;

  p{
    color: #0E4C54;
    font-size: 12px !important;
  }
`;

export const LoadingButton = styled(Loading)`

  Spinner{
    color: #E02828 !important;
  }
`;

export const DuplicateItemLine = styled.div` 
    display: flex;
    position: absolute;
    top: -25%;
    left: -1%;

    img{
      height: 32px;
    }
`;